import * as React from "react";
declare const I18n;

type Props = {
  description: string;
  linkText?: string;
  link?: string;
};

const AnnouncementBar: React.FunctionComponent<Props> = ({
  description,
  linkText,
  link
}: Props): JSX.Element => {

  return (
    <div 
      className="alert alert-info" 
      role="alert" 
      style={{ 
        textAlign: "center",
        fontSize: "14px"
      }}
    >
      <span style={{ maxWidth: "90%" }}>{description}{" "}</span>
      {link && linkText && (
        <span>
          <a href={link}>
            {linkText}
          </a>
        </span>
      )}
    </div>
  );
};

export default AnnouncementBar;